import { type ChainFullId } from "@umami/chains";
import { useDynamicModalContext } from "@umami/components";
import { type Provider } from "@umami/ramp";
import { useCurrentAccount } from "@umami/state";
import { type ReactElement } from "react";

import { AssetSelectModal } from "@/components/AssetSelectModal";
import { FormPage as BuyTokenFormPage, type QuoteParams } from "@/components/Buy/FormPage";
import { BuyProviderModal } from "@/components/BuyProviderModal";
import { ProviderSelectModal } from "@/components/ProviderSelectModal";

export const useBuyTokenFlow = () => {
  const { openWith } = useDynamicModalContext();
  const currentAccount = useCurrentAccount()!;

  const handleBuy = async (tokenName: string, tokenChain: ChainFullId, iconUrl?: string) => {
    await openWith(
      (
        <BuyTokenFormPage
          fiatCurrency="USD"
          iconUrl={iconUrl}
          name={tokenName}
          network={tokenChain}
          onBuyClick={handleBuyClick}
          onProviderSelect={handleProviderSelect}
          sender={currentAccount}
          tokenSymbol={tokenName}
        />
      ) as ReactElement
    );
  };

  const handleBuyClick = async (apiUrl: string, openInNewTab: boolean) => {
    await openWith(
      (<BuyProviderModal apiUrl={apiUrl} openInNewTab={openInNewTab} />) as ReactElement
    );
  };

  const handleProviderSelect = async (
    amount: string,
    providers: Provider[],
    quoteParams: QuoteParams
  ) => {
    await openWith(
      (
        <ProviderSelectModal amount={amount} providers={providers} quoteParams={quoteParams} />
      ) as ReactElement
    );
  };

  const handleAssetSelectClick = async () => {
    await openWith(
      (
        <AssetSelectModal
          onClick={(tokenName, tokenChain, iconUrl) => {
            void handleBuy(tokenName, tokenChain, iconUrl);
          }}
        />
      ) as ReactElement
    );
  };

  return {
    handleAssetSelectClick,
  };
};
